const load = {
  namespaced: true,
  state: {
    loading: {}
  },
  getters: {},
  mutations: {
    SET_LOADING: (state, payload) => {
      // 直接修改object的值，vuex不能动态更新，需使用Object.assign
      state.loading = Object.assign({}, state.loading, { [payload.type]: payload.loading })
    }
  },
  actions: {
    setLoading ({ commit }, payload) {
      commit('SET_LOADING', payload)
    }
  }
}

export default load



// WEBPACK FOOTER //
// ./src/store/modules/load.js